@if (format === 'search_list') {
    <div class="search-list-tour">
        @if (entry.partnership_level === 'elite') {
            <div class="partner"></div>
        }
        <div>{{ entry.name }}</div>
        @if (isSameDay(entry.start_date, entry.end_date)) {
            <div>{{ localizeDate(entry.start_date) }}</div>
        }

        @if (!isSameDay(entry.start_date, entry.end_date)) {
            <div>{{ localizeDate(entry.start_date) }} - {{ localizeDate(entry.end_date) }}</div>
        }
    </div>
}

@if (format === 'standard') {
    <section
        class="tournament-card-filter-logos"
        [class]="showStatus(entry) ? 'status-padding' : ''"
        [style.marginBottom]="margin_bottom"
        [style.aspectRatio]="handleRatio(entry)"
        [style.backgroundImage]="handleBackground(entry.image_url)"
    >
        @if (showStatus(entry)) {
            <div class="live-status">
                <mat-icon> {{ entry.is_suspended ? 'hourglass_empty' : 'sensors' }} </mat-icon>
                {{ appStringAPI.getAppString(statusString(entry)).toUpperCase() }}
            </div>
        }

        @if (entry.partnership_level === 'elite') {
            <div class="partner"></div>
        }

        <div class="card-content">
            @if (entry.theme.logo_url) {
                <img [src]="entry.theme.logo_url" class="tour-logo" onerror='this.style.display = "none"' />
            }

            <div class="title">{{ entry.name }}</div>

            @if (hasTourTypes()) {
                <div class="tour-types">
                    {{ tourTypesLabel }}
                </div>
            }

            @if (isSameDay(entry.start_date, entry.end_date)) {
                <div class="span">{{ localizeDate(entry.start_date) }}</div>
            }

            @if (!isSameDay(entry.start_date, entry.end_date)) {
                <div class="span">{{ localizeDate(entry.start_date) }} - {{ localizeDate(entry.end_date) }}</div>
            }
        </div>
        @if (entry.purse) {
            <div class="purse">{{ appStringAPI.getAppString('golf.purse') }} {{ entry.purse }}</div>
        }
    </section>
}

@if (format === 'square') {
    <section class="tournament-card square" [style.marginBottom]="margin_bottom" style="aspect-ratio: 1 / 1" [style.backgroundImage]="handleBackground(entry.image_url)">
        @if (entry.partnership_level === 'elite') {
            <div class="partner"></div>
        }

        @if (entry.partnership_level === 'elite') {
            <img [src]="entry.theme.logo_url" class="elite-logo" onerror="this.style.display = 'none'" />
        }

        <div class="title">
            {{ entry.name }}
        </div>

        @if (hasTourTypes()) {
            <div class="tour-types square-tour-types">
                {{ tourTypesLabel }}
            </div>
        }

        @if (squareMetaText) {
            <div class="meta-line square-meta-line">{{ squareMetaText }}</div>
        }

        @if (isSameDay(entry.start_date, entry.end_date)) {
            <div class="span">
                {{ localizeDate(entry.start_date) }}
            </div>
        }

        @if (!isSameDay(entry.start_date, entry.end_date)) {
            <div class="span">{{ localizeDate(entry.start_date) }} - {{ localizeDate(entry.end_date) }}</div>
        }
    </section>
}
